import { Routes, Route, useLocation, Navigate } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import Dashboard from './Dashboard'
import BrainstormTasks from './BrainstormTasks'
import Bitcoin from './tickers/Bitcoin'
import Ethereum from './tickers/Ethereum'
import Strategy from './tickers/Strategy'
import MSTY from './tickers/MSTY'
import CryptoQuantSentiments from './CryptoQuantSentiments'
import CryptoQuantDetailedSentiments from './CryptoQuantDetailedSentiments'
import Education from './pages/Education'
import Fun from './pages/Fun'
import IncrementalAllocations from './pages/IncrementalAllocations'
import OptionsHeatMap from './pages/OptionsHeatMap'
import PortfolioManagement from './pages/PortfolioManagement'
import TangentalAssets from './pages/TangentalAssets'
import { ProtectedRoute } from './components/ProtectedRoute'
import AdminRoute from './components/AdminRoute'
import Login from './pages/Login'
import Administration from './pages/Administration'
import Home from './pages/Home'
import Capriole from './pages/Capriole'

const AnimatedRoutes = (): JSX.Element => {
  const location = useLocation()

  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/crypto" element={<CryptoQuantSentiments />} />
        <Route path="/crypto/:symbol" element={<CryptoQuantDetailedSentiments />} />
        <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard ticker="MSTY" subtitle="Strategy Options Fund (MSTY) - Comprehensive Analysis" />} />} />
        <Route path="/education" element={<Education />} />
        <Route path="/fun" element={<Fun />} />
        <Route path="/options-heat-map" element={<OptionsHeatMap />} />
        <Route path="/portfolio-management" element={<PortfolioManagement />} />
        <Route path="/tangental-assets" element={<TangentalAssets />} />
        <Route path="/incremental-allocations" element={<IncrementalAllocations />} />
        <Route path="/tpi" element={<Dashboard ticker="TPI" subtitle="TPI Analysis" />} />
        <Route path="/tpi/:symbol" element={<Dashboard subtitle="TPI Analysis" />} />
        <Route path="/bitcoin" element={<ProtectedRoute element={<Bitcoin />} />} />
        <Route path="/strategy" element={<ProtectedRoute element={<Strategy />} />} />
        <Route path="/msty" element={<ProtectedRoute element={<MSTY />} />} />
        <Route path="/ethereum" element={<ProtectedRoute element={<Ethereum />} />} />
        <Route path="/cryptoquant-sentiments" element={<ProtectedRoute element={<CryptoQuantSentiments />} />} />
        <Route path="/cryptoquant-detailed-sentiments" element={<ProtectedRoute element={<CryptoQuantDetailedSentiments />} />} />
        <Route path="/capriole" element={<ProtectedRoute element={<Capriole />} />} />
        <Route path="/brainstorm" element={<AdminRoute element={<BrainstormTasks />} />} />
        <Route path="/admin" element={<AdminRoute element={<Administration />} />} />
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AnimatePresence>
  )
}

export default AnimatedRoutes
